import { computedAsync } from '@vueuse/core'
import { OrganizationsService } from '@itemis-solutions/platform-client-sdk'
import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useOrganizations = defineStore('Organizations', () => {
  const loadingOrganizations = ref(false)

  const organizations = computedAsync(
    () => OrganizationsService.getOrganizations({}).then((resp) => resp.data),
    [],
    {
      lazy: true,
      evaluating: loadingOrganizations,
    },
  )
  return { loadingOrganizations, organizations }
})
